<template>
  <div
    class="score-modal-objectives__list flat-scrol score-modal-objectives__responsive-from-tablet"
  >
    <div
      v-for="(domain, key) in domains"
      class="score-modal-objectives__wrapper"
      :key="key"
    >
      <div class="score-modal-objectives__list-header">
        <div class="score-modal-objectives__header-wrapper">
          <h5 class="score-modal-objectives__domain-name">
            {{ cleanKeyName(key) }}
          </h5>
          <div class="score-modal-objectives--mobile">
            <CheckIcon
              class="score-modal-objectives score-modal-objectives--passed"
              v-if="domain.domain_passed"
            />
            <XIcon
              class="score-modal-objectives score-modal-objectives--failed"
              v-else
            />
          </div>
        </div>
        <div class="score-modal-objectives__domain-score-wrapper">
          <div
            class="score-modal-objectives__domain-score"
            v-if="roundTo2(domain.min_score_to_pass) > 0"
          >
            <span class="score-modal-objectives__domain-score-label"
              >Required score:</span
            >
            <span class="score-modal-objectives__domain-score-result"
              >{{ roundTo2(domain.min_score_to_pass) }}%</span
            >
          </div>
          <div class="score-modal-objectives__domain-score">
            <span class="score-modal-objectives__domain-score-label"
              >Your score:</span
            >
            <span class="score-modal-objectives__domain-score-result"
              >{{ roundTo2(domain.score) }}%</span
            >
          </div>
          <div class="score-modal-objectives--tablet">
            <CheckIcon
              class="score-modal-objectives score-modal-objectives--passed"
              v-if="domain.domain_passed"
            />
            <XIcon
              class="score-modal-objectives score-modal-objectives--failed"
              v-else
            />
          </div>
        </div>
      </div>
      <div class="score-modal-objectives__objectives-wrapper">
        <div
          class="score-modal-objectives__objective"
          v-for="(objective, key) in domain.objectives"
          :key="key"
        >
          <span class="score-modal-objectives__objective-name">
            {{ cleanKeyName(key) }}
          </span>
          <span
            class="score-modal-objectives__objective-score"
            :class="
              !objective.objective_passed &&
                'score-modal-objectives__objective-score-failed'
            "
          >
            {{ objective.passed_questions }}/{{ objective.total_questions }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckIcon, XIcon } from 'vue-feather-icons'

export default {
  name: 'ExamScoreModalObjectives',
  components: {
    CheckIcon,
    XIcon,
  },
  props: {
    domains: {
      type: Object,
      required: true,
    },
  },
  methods: {
    roundTo2(n) {
      return Math.floor(n * 100)
    },
    domainStatusLabel(domain) {
      return domain.domain_passed ? 'Passed' : 'Failed'
    },
    cleanKeyName(name) {
      return name.replace(/^([0-9]+. )/, '')
    },
  },
}
</script>
